
export default function Footer() {
  return (
    <footer className="bg-gray-100 pt-16 pb-8">
      <div className="container mx-auto px-6 max-w-6xl">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 bg-gray-900 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-2xl">B</span>
              </div>
            </div>
            <p className="text-sm text-gray-600">
              Bumblebee Data, Inc. - All rights reserved.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-bold text-gray-900 mb-4">The Company</h3>
            <ul className="space-y-2">
              <li>
                <a href="https://hi-bumblebee.com/about-us/" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  About us
                </a>
              </li>
              <li>
                <a href="https://trello.com/b/Zfn2zoP7/bumblebee-product-roadmap" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  Product Roadmap
                </a>
              </li>
              <li>
                <a href="https://www.notion.so/argenisleon/Product-Updates-1f3b4bdb62e4410b9a9341eb16d93e1f" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  Product Updates
                </a>
              </li>
              <li>
                <a href="https://medium.com/hi-bumblebee" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  Blog
                </a>
              </li>
              <li>
                <a href="/careers" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  Careers
                </a>
              </li>
              <li>
                <a href="https://hi-bumblebee.slack.com/join/shared_invite/zt-evy3pz9h-gGjkD2Oy26PihxRD~Jg2fw" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  Community
                </a>
              </li>
            </ul>
          </div>

          <div>
            <div className="flex gap-4 mb-6">
              <a href="https://medium.com/hi-bumblebee" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center cursor-pointer hover:opacity-70 transition-opacity">
                <i className="ri-medium-fill text-2xl text-gray-700"></i>
              </a>
              <a href="https://github.com/ironmussa/Bumblebee" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center cursor-pointer hover:opacity-70 transition-opacity">
                <i className="ri-github-fill text-2xl text-gray-700"></i>
              </a>
              <a href="https://www.linkedin.com/company/bumblebee-data/" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center cursor-pointer hover:opacity-70 transition-opacity">
                <i className="ri-linkedin-fill text-2xl text-gray-700"></i>
              </a>
              <a href="https://twitter.com/hi_bumblebee" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center cursor-pointer hover:opacity-70 transition-opacity">
                <i className="ri-twitter-x-fill text-2xl text-gray-700"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-300 pt-8">
          <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-600">
            <a href="mailto:support@hi-bumblebee.com" className="hover:text-gray-900 transition-colors cursor-pointer">
              support@hi-bumblebee.com
            </a>
            <a href="/privacy-policy" className="hover:text-gray-900 transition-colors cursor-pointer">
              Privacy Policy
            </a>
            <a href="/terms-of-service" className="hover:text-gray-900 transition-colors cursor-pointer">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
